module.exports = __webpack_public_path__ + "img/879-4d1049.png";